module.exports = __webpack_public_path__ + "static/media/banner.0ad647ef.svg";